import { render, staticRenderFns } from "./OfferRestrictions.vue?vue&type=template&id=124cc702&scoped=true"
import script from "./OfferRestrictions.vue?vue&type=script&lang=js"
export * from "./OfferRestrictions.vue?vue&type=script&lang=js"
import style0 from "./OfferRestrictions.vue?vue&type=style&index=0&id=124cc702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124cc702",
  null
  
)

export default component.exports